import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import CONFIG from '../../app-configs'
import { ApiAuthStrategies } from '../shared/ApiAuthStrategies'

export const activityStatementApi = createApi({
  reducerPath: 'activityStatementApi',

  baseQuery: fetchBaseQuery({
    baseUrl: `${CONFIG.PROXIMA_BACK_END_V2_BASE_API_URL}/asset-holdings`,
    prepareHeaders: (headers: Headers, { getState }) => {
      const authToken = ApiAuthStrategies.getBearerTokenHeader()
      headers.set('authorization', authToken)
      return headers
    }
  }),

  endpoints: (builder) => ({
    getActivityStatementSignedUrl: builder.query({
      query: ({ assetHolderId, startDate, endDate }) => ({
        url: `asset-holders/admin/${assetHolderId}/activity-statement/generate-signed-url-for-view`,
        params: {
          startDate,
          endDate
        }
      })
    })
  })
})

export const useGetActivityStatementSignedUrl = activityStatementApi.endpoints.getActivityStatementSignedUrl.useLazyQuery
